// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import * as React from 'react'
import { useSpring } from 'react-spring'
import { useMeasure } from 'react-use'

import { TypeStyleBodyMicro } from '@syconium/little-miss-figgy'

import { PricingRange } from '../../../../../app/_components/pricing/PricingRange.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../../lib/analytics'
import { useGoogleTagManager } from '../../../../../lib/hooks/useGoogleTagManager'

import { IProps } from './IProps'
import { ProductName } from './ProductName'
import {
  AutoCompleteResults,
  Container,
  ErrorContainer,
  ErrorMessage,
  PopularSearchItem,
  PopularSearchResults,
  PopularSearchTitle,
  Prices,
  ProductDetails,
  ProductTile,
  StyledResponsiveImage,
  imageSize,
} from './styles'

function noOp(): void {}

export const SearchOverlayResults: React.FC<IProps> = ({
  autoCompleteResults,
  hasError,
  onClearFormClick = noOp,
  onClickSearchOverlayProduct = noOp,
  popularSearchResults,
  popularSearchTitle,
  searchText,
}) => {
  const { search: searchCopy } = useTranslation()
  const { pushProductClick } = useGoogleTagManager()

  const [bind, { height }] = useMeasure<HTMLDivElement>()

  const containerSpring = useSpring({
    height: autoCompleteResults.length > 0 || popularSearchResults.length > 0 ? height : 0,
  })

  return (
    <>
      <Container style={containerSpring}>
        <div ref={bind}>
          {!hasError && (
            <>
              {autoCompleteResults.length > 0 && (
                <AutoCompleteResults aria-label='Search results'>
                  {autoCompleteResults.map((result, index) => {
                    return (
                      <ProductTile
                        role='listitem'
                        key={`${index}-${result.id}`}
                        {...trackEvent({
                          category: 'search',
                          action: 'click',
                          label: 'search result',
                          value: result.title,
                          customAttributes: {
                            'data-heap-position': `${index + 1}`,
                            'data-heap-location': 'nav',
                          },
                        })}
                      >
                        <Link
                          onClick={() => {
                            pushProductClick({
                              variant: {
                                category: result.categoryAnalyticsId,
                                currencyType: result.currencyCode,
                                externalParentId: '',
                                discountPrice: result.discountPrice ?? null,
                                handle: result.deprecatedProductHandle,
                                price: result.price,
                                sku: '', // We can't provide this data. You don't pick a variant here.
                                shopifyId: result.shopifyId,
                              },
                              list: 'instant-search-results',
                              position: index,
                            })
                            onClickSearchOverlayProduct({ query: searchText, id: result.shopifyId })
                          }}
                          href={result.url}
                        >
                          {result.imageSrc && (
                            <StyledResponsiveImage
                              alt={result.title}
                              src={result.imageSrc}
                              widths={{ unit: 'px', sm: imageSize, md: imageSize }}
                              aspectRatios={{ sm: 1, md: 1 }}
                              loading='default'
                            />
                          )}
                          <ProductDetails>
                            <ProductName allText={result.title} targetText={searchText} />
                            {result.pricing ? (
                              <Prices>
                                <TypeStyleBodyMicro color='primary'>
                                  <PricingRange
                                    {...result.pricing}
                                    upToPercentageOff={null}
                                    percentageOff={null}
                                  />
                                </TypeStyleBodyMicro>
                              </Prices>
                            ) : null}
                          </ProductDetails>
                        </Link>
                      </ProductTile>
                    )
                  })}
                </AutoCompleteResults>
              )}

              {popularSearchResults.length > 0 && (
                <PopularSearchResults>
                  <PopularSearchTitle>{popularSearchTitle}</PopularSearchTitle>
                  <ul>
                    {popularSearchResults.map((search, index) => (
                      <PopularSearchItem key={`${search}-${index}`}>
                        <Link
                          href={`/search?q=${search}`}
                          onClick={onClearFormClick}
                          {...trackEvent({
                            category: 'search',
                            action: 'click',
                            label: 'suggested search',
                            value: search,
                            customAttributes: {
                              'data-heap-position': `${index + 1}`,
                              'data-heap-location': 'nav',
                            },
                          })}
                        >
                          {search}
                        </Link>
                      </PopularSearchItem>
                    ))}
                  </ul>
                </PopularSearchResults>
              )}
            </>
          )}
        </div>
      </Container>
      {hasError && (
        <ErrorContainer>
          <ErrorMessage>{searchCopy.errorMessage}</ErrorMessage>
        </ErrorContainer>
      )}
    </>
  )
}
